export default "__VITE_PUBLIC_ASSET__9f3a85d2__"